
import Vue from "vue"

export default Vue.extend({
  name: "AlertError.vue",
  props: {
    message: String
  }
})
